import { Label } from '../../../label';
import * as React from 'react';
import { clsx } from 'clsx';
import styles from './Tab.module.css';
import { Counter } from '../../../internal/components/Counter';
import { LABEL_COLORS_DEFAULT } from '../../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Tab = _ref => {
  let {
    labelText,
    labelColors: {
      background: labelBackground,
      color: labelTextColor
    } = LABEL_COLORS_DEFAULT,
    icon: Icon,
    text,
    rightItem,
    counterType,
    counter,
    counterMaxLength,
    isActive,
    size,
    disabled,
    badged,
    dataTestId,
    onClick,
    onKeyDown
  } = _ref;
  return /*#__PURE__*/_jsxs("li", {
    className: clsx(styles['tab'], {
      [styles['tab--active']]: isActive,
      [styles['tab--small']]: size === 'S',
      [styles['tab--medium']]: size === 'M',
      [styles['tab--disabled']]: disabled
    }),
    onClick: onClick,
    onKeyDown: onKeyDown,
    tabIndex: disabled ? -1 : 0,
    "data-testid": dataTestId,
    children: [labelText && /*#__PURE__*/_jsx(Label, {
      background: labelBackground,
      color: labelTextColor,
      children: labelText
    }), Icon && /*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx(Icon, {
        color: "current_color"
      })
    }), /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: text
    }), rightItem && /*#__PURE__*/_jsxs("div", {
      className: styles['right-item'],
      children: [rightItem === 'counter' && !!counter && /*#__PURE__*/_jsx("div", {
        className: clsx(styles['counter-container'], {
          [styles['counter-container--accent']]: !labelText && counterType === 'accent'
        }),
        children: /*#__PURE__*/_jsx(Counter, {
          counter: counter,
          counterMaxLength: counterMaxLength,
          className: styles['counter']
        })
      }), rightItem === 'badge' && badged && !labelText && /*#__PURE__*/_jsx("div", {
        className: styles['badge']
      })]
    })]
  });
};